import {
  allRequest,
  getRequest,
  postRequest,
  REQUEST_METHOD_DELETE,
  REQUEST_METHOD_GET,
  REQUEST_METHOD_POST
} from "../../middlewares/api/actions";
import {
  getAgencyNamesUrl,
  getCodelistUrl,
  getConceptSchemeUrl,
  getConvertXlsToCsv,
  getCreateArtefactsUrl,
  getCsvHeaderUrl,
  getCsvTableColumnPreviewUrl,
  getCsvTablePreviewUrl,
  getDataflowUrl,
  getDataUploadStatusUrl,
  getDcsUrl,
  getDdbDataflowUrl,
  getDeleteArtefactUrl,
  getDsdUrl,
  getEasyLoadDataFromDbUrl,
  getEasyLoadDataFromFileUrl,
  getEasyLoadDataFromSdmxUrl,
  getEasyUpdateDataFromDbUrl,
  getEasyUpdateDataFromFileUrl,
  getEasyUpdateDataFromSdmxUrl,
  getFileFromStagingAreaTableUrl,
  getImportDSDFromDataflowUrl,
  getNodePingUrl,
  getPartialCodelistUrl,
  getPreloadCsvUrl,
  getStagingAreaTablesUrl,
  getUploadFileOnServerAbsoluteUrl,
  getUploadFileOnServerUrl
} from "../../constants/urls";
import {getFilterObjFromStr, getServerQueryObj} from "../../utils/filter";
import {convertFilterStrWithSimpleFilterForTimePeriod} from "../tree-filter/utils";
import { getCreateFileComponentMapping, getCreateCodelistsRequests, getCreateConceptRequest, getDataflowDSD, getUpdateFileComponentMapping } from "./load-step/utils";
import { getArtefactTripletFromString, getSdmxJsonFromSdmxJsonStructures, getSdmxJsonStructureFromDsd, SDMX_JSON_DSD_LIST_KEY } from "../../utils/sdmxJson";

export const EL_STEP_SET = "EL_STEP_SET";
export const EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT = "EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT";

/* data step */
export const EL_AGENCIES_READ = "EL_AGENCIES_READ";
export const EL_CATEGORIES_READ = "EL_CATEGORIES_READ";
export const EL_CATEGORY_SET = "EL_CATEGORY_SET";
export const EL_DST_DATAFLOW_FORM_CHANGE = "EL_DST_DATAFLOW_FORM_CHANGE";
export const EL_DST_DATAFLOWS_READ = "EL_DST_DATAFLOWS_READ";
export const EL_DST_DATAFLOW_SET = "EL_DST_DATAFLOW_SET";
export const EL_DST_DATAFLOW_UNSET = "EL_DST_DATAFLOW_UNSET";

/* connection step */
export const EL_SOURCE_FORMAT_SET = "EL_SOURCE_FORMAT_SET";
export const EL_CONNECTION_ENDPOINT_SET = "EL_CONNECTION_ENDPOINT_SET";
export const EL_CONNECTION_ENDPOINT_PING = "EL_CONNECTION_ENDPOINT_PING";
export const EL_SRC_DATAFLOWS_READ = "EL_SRC_DATAFLOWS_READ";
export const EL_SRC_DATAFLOW_SET = "EL_SRC_DATAFLOW_SET";
export const EL_SRC_DATAFLOW_UNSET = "EL_SRC_DATAFLOW_UNSET";
export const EL_SRC_FILE_FORM_CHANGE = "EL_SRC_FILE_FORM_CHANGE";
export const EL_SRC_FILE_CSV_UPLOAD = "EL_SRC_FILE_CSV_UPLOAD";
export const EL_SRC_FILE_EXCEL_UPLOAD = "EL_SRC_FILE_EXCEL_UPLOAD";
export const EL_SRC_FILE_EXCEL_CONVERT = "EL_SRC_FILE_EXCEL_CONVERT";
export const EL_SRC_FILE_PREVIEW_SHOW = "EL_SRC_FILE_PREVIEW_SHOW";
export const EL_SRC_FILE_PREVIEW_HIDE = "EL_SRC_FILE_PREVIEW_HIDE";
export const EL_SRC_FILE_PREVIEW_READ = "EL_SRC_FILE_PREVIEW_READ";
export const EL_SRC_TABLES_READ = "EL_SRC_TABLES_READ";
export const EL_SRC_TABLE_SET = "EL_SRC_TABLE_SET";

/* filter step */
export const EL_SRC_DATAFLOW_DSD_READ = "EL_SRC_DATAFLOW_DSD_READ";
export const EL_CODELIST_COUNT_READ = "EL_CODELIST_COUNT_READ";
export const EL_CODELIST_ITEMS_READ = "EL_CODELIST_ITEMS_READ";
export const EL_CSV_HEADER_READ = "EL_CSV_HEADER_READ";
export const EL_CSV_COUNT_AND_ITEMS_READ = "EL_CSV_COUNT_AND_ITEMS_READ";
export const EL_FILTER_MODE_CHANGE = "EL_FILTER_MODE_CHANGE";
export const EL_FILTER_MODE_ADVANCED_VALUES_CHANGE = "EL_FILTER_MODE_ADVANCED_VALUES_CHANGE";
export const EL_FILTER_MODE_ADVANCED_MODE_CHANGE = "EL_FILTER_MODE_ADVANCED_MODE_CHANGE";
export const EL_FILTER_MODE_SIMPLE_BLOCK_ADD = "EL_FILTER_MODE_SIMPLE_BLOCK_ADD";
export const EL_FILTER_MODE_SIMPLE_BLOCK_DELETE = "EL_FILTER_MODE_SIMPLE_BLOCK_DELETE";
export const EL_FILTER_MODE_SIMPLE_CONDITION_ADD = "EL_FILTER_MODE_SIMPLE_CONDITION_ADD";
export const EL_FILTER_MODE_SIMPLE_CONDITION_DELETE = "EL_FILTER_MODE_SIMPLE_CONDITION_DELETE";
export const EL_FILTER_MODE_SIMPLE_VALUES_CHANGE = "EL_FILTER_MODE_SIMPLE_VALUES_CHANGE";
export const EL_FILTER_MODE_SIMPLE_VALUES_READ = "EL_FILTER_MODE_SIMPLE_VALUES_READ";
export const EL_FILTER_MODE_SIMPLE_VALUES_RESET = "EL_FILTER_MODE_SIMPLE_VALUES_RESET";
export const EL_FILTER_RESET = "EL_FILTER_RESET";

/* structure step */
export const EL_STRUCTURE_CSV_HEADER_READ = "EL_STRUCTURE_CSV_HEADER_READ";
export const EL_STRUCTURE_COLUMN_TYPE_SET = "EL_STRUCTURE_COLUMN_TYPE_SET";

/* dimensions step */
export const EL_DIMENSIONS_COLUMNS_SET = "EL_DIMENSIONS_COLUMNS_SET";
export const EL_CODELISTS_READ = "EL_CODELISTS_READ";

/* attributes step */
export const EL_ATTRIBUTES_COLUMNS_SET = "EL_ATTRIBUTES_COLUMNS_SET";

/* semantic step */
export const EL_SEMANTIC_COLUMNS_SET = "EL_SEMANTIC_COLUMNS_SET";
export const EL_CONCEPT_SCHEMES_READ = "EL_CONCEPT_SCHEMES_READ";
export const EL_CONCEPTS_READ = "EL_CONCEPTS_READ";
export const EL_CONCEPTS_CLEAR = "EL_CONCEPTS_CLEAR";

/* load step */
export const EL_METADATA_SUBMIT = "EL_METADATA_SUBMIT";
export const EL_METADATA_REPORT_HIDE = "EL_METADATA_REPORT_HIDE";
export const EL_PUBLISH_DATAFLOW_CHANGE = "EL_PUBLISH_DATAFLOW_CHANGE";
export const EL_TRANSCODE_DATAFLOW_CHANGE = "EL_TRANSCODE_DATAFLOW_CHANGE";
export const EL_DATA_CREATE_SUBMIT = "EL_DATA_CREATE_SUBMIT";
export const EL_DATA_UPDATE_SUBMIT = "EL_DATA_UPDATE_SUBMIT";
export const EL_DATA_CREATE_FROM_FILE_SUBMIT = "EL_DATA_CREATE_FROM_FILE_SUBMIT";
export const EL_DATA_UPDATE_FROM_FILE_SUBMIT = "EL_DATA_UPDATE_FROM_FILE_SUBMIT";
export const EL_DATA_UPDATE_FROM_DB_SUBMIT = "EL_DATA_UPDATE_FROM_DB_SUBMIT";
export const EL_DATA_CREATE_FROM_DB_SUBMIT = "EL_DATA_CREATE_FROM_DB_SUBMIT";
export const EL_DATA_IMPORT_STATUS_GET = "EL_DATA_IMPORT_STATUS_GET";
export const EL_METADATA_CSV_PRELOAD = "EL_METADATA_CSV_PRELOAD";
export const EL_LOAD_TABLE_SET_EXISTS = "EL_LOAD_TABLE_SET_EXISTS";
export const EL_CREATE_ARTEFACTS = "EL_CREATE_ARTEFACTS";
export const EL_DELETE_CREATED_ARTEFACTS = "EL_DELETE_CREATED_ARTEFACTS";
export const EL_CREATE_DSD = "EL_CREATE_DSD";
export const EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE = "EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE";
export const EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE = "EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE";

export const EL_RESET = "EL_RESET";

export const setELStep = step => ({
  type: EL_STEP_SET,
  step
});

export const readElAgencies = allowedAgencies => ({
  ...getRequest(
    EL_AGENCIES_READ,
    getAgencyNamesUrl()
  ),
  allowedAgencies
});

export const readELCategories = () => getRequest(
  EL_CATEGORIES_READ,
  getDcsUrl()
);

export const setELCategory = category => ({
  type: EL_CATEGORY_SET,
  category
});

export const changeELDstDataflowForm = fields => ({
  type: EL_DST_DATAFLOW_FORM_CHANGE,
  fields
});

export const readELDstDataflows = () => allRequest(
  EL_DST_DATAFLOWS_READ,
  [REQUEST_METHOD_GET, REQUEST_METHOD_GET],
  [getDdbDataflowUrl(), getDataflowUrl()]
);

export const setELDstDataflow = dataflow => ({
  type: EL_DST_DATAFLOW_SET,
  dataflow
});

export const unsetELDstDataflow = () => ({
  type: EL_DST_DATAFLOW_UNSET
});

export const setELSourceFormat = format => ({
  type: EL_SOURCE_FORMAT_SET,
  format
});

export const setElConnectionEndpoint = endpointId => ({
  type: EL_CONNECTION_ENDPOINT_SET,
  endpointId
});

export const pingELConnectionEndpoint = endpointId => getRequest(
  EL_CONNECTION_ENDPOINT_PING,
  getNodePingUrl(),
  undefined,
  undefined,
  endpointId
);

export const readELSrcDataflows = endpointId => getRequest(
  EL_SRC_DATAFLOWS_READ,
  getDataflowUrl(),
  undefined,
  undefined,
  endpointId
);

export const setELSrcDataflow = dataflow => ({
  type: EL_SRC_DATAFLOW_SET,
  dataflow
});

export const unsetELSrcDataflow = () => ({
  type: EL_SRC_DATAFLOW_UNSET
});

export const changeELSrcFileForm = fields => ({
  type: EL_SRC_FILE_FORM_CHANGE,
  fields
});

export const uploadElSrcFileCsv = file => {
  const fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    EL_SRC_FILE_CSV_UPLOAD,
    getUploadFileOnServerUrl(),
    fileFormData,
    t => ({
      start: t('components.easyLoading.messages.srcFileUpload.start'),
      success: t('components.easyLoading.messages.srcFileUpload.success')
    })
  );
};

export const uploadElSrcFileCsvAbsolute = file => {
  const fileFormData = new FormData();
  fileFormData.append('file', file);

  return postRequest(
    EL_SRC_FILE_CSV_UPLOAD_ABSOLUTE,
    getUploadFileOnServerAbsoluteUrl(true),
    fileFormData
  );
};



export const uploadElSrcFileExcel = (file, mappingFile) => {

  const fileFormData = new FormData();
  fileFormData.append('file', file);

  const mappingFileFormData = new FormData();
  mappingFileFormData.append('file', mappingFile);

  return allRequest(
    EL_SRC_FILE_EXCEL_UPLOAD,
    [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
    [getUploadFileOnServerUrl(), getUploadFileOnServerUrl()],
    [fileFormData, mappingFileFormData],
    t => ({
      start: t('components.easyLoading.messages.srcFileUpload.start'),
      success: t('components.easyLoading.messages.srcFileUpload.success')
    })
  );
};

export const uploadElSrcFileXlsAbsolute = (file, mappingFile) => {

  const fileFormData = new FormData();
  fileFormData.append('file', file);

  const mappingFileFormData = new FormData();
  mappingFileFormData.append('file', mappingFile);

  return allRequest(
    EL_SRC_FILE_EXCEL_UPLOAD_ABSOLUTE,
    [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
    [getUploadFileOnServerAbsoluteUrl(true), getUploadFileOnServerAbsoluteUrl(true)],
    [fileFormData, mappingFileFormData]
  );
};

export const convertElSrcFileExcel = (filePath, mappingPath) => getRequest(
  EL_SRC_FILE_EXCEL_CONVERT,
  getConvertXlsToCsv(filePath, mappingPath, 0)
);

export const showElSrcFilePreview = () => ({
  type: EL_SRC_FILE_PREVIEW_SHOW
});

export const hideElSrcFilePreview = () => ({
  type: EL_SRC_FILE_PREVIEW_HIDE
});

export const readElSrcFilePreview = (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, csvPath) => postRequest(
  EL_SRC_FILE_PREVIEW_READ,
  getCsvTablePreviewUrl(separator, delimiter, hasHeader, csvPath, null, null),
  {
    PageNum: pageNum,
    PageSize: pageSize,
    FilterTable: filterTable,
    SortCols: sortCols,
    SortByDesc: sortByDesc
  }
);

export const readElSrcTables = () => getRequest(
  EL_SRC_TABLES_READ,
  getStagingAreaTablesUrl()
);

export const setElSrcTable = (tableName, csvSeparator) => ({
  ...postRequest(
    EL_SRC_TABLE_SET,
    getFileFromStagingAreaTableUrl(tableName, csvSeparator),
    getServerQueryObj(null, getFilterObjFromStr("")).Filter,
  ),
  tableName
});

export const readELSrcDataflowDsd = (dsdTriplet, endpointId) => getRequest(
  EL_SRC_DATAFLOW_DSD_READ,
  getDsdUrl(dsdTriplet),
  undefined,
  undefined,
  endpointId
);

export const readELCodelistCount = (sdcDataflowTriplet, dimensionId, endpointId) => ({
  ...getRequest(
    EL_CODELIST_COUNT_READ,
    getPartialCodelistUrl(sdcDataflowTriplet, dimensionId, 1, 0),
    undefined,
    undefined,
    endpointId
  ),
  dimensionId
});

export const readELCodelistItems = (sdcDataflowTriplet, dimensionId, endpointId) => ({
  ...getRequest(
    EL_CODELIST_ITEMS_READ,
    getPartialCodelistUrl(sdcDataflowTriplet, dimensionId, 1, -1),
    undefined,
    undefined,
    endpointId
  ),
  dimensionId
});

export const readELCsvHeader = (csvSeparator, csvDelimiter, csvHasHeader, csvServerPath) => getRequest(
  EL_CSV_HEADER_READ,
  getCsvHeaderUrl(csvSeparator, csvDelimiter, csvHasHeader, csvServerPath)
);

export const readELCsvCountAndItems = (dimensionId, separator, delimiter, hasHeader, csvPath) => ({
  ...postRequest(
    EL_CSV_COUNT_AND_ITEMS_READ,
    getCsvTableColumnPreviewUrl(separator, delimiter, hasHeader, csvPath),
    {
      SelCols: [dimensionId],
      PageNum: 1,
      PageSize: -1
    }
  ),
  dimensionId
});

export const changeELFilterMode = mode => ({
  type: EL_FILTER_MODE_CHANGE,
  mode
});

export const changeELFilterModeAdvancedValues = (colName, values) => ({
  type: EL_FILTER_MODE_ADVANCED_VALUES_CHANGE,
  colName,
  values
});

export const changeELFilterModeAdvancedMode = (colName, mode) => ({
  type: EL_FILTER_MODE_ADVANCED_MODE_CHANGE,
  colName,
  mode
});

export const addELFilterModeSimpleBlock = () => ({
  type: EL_FILTER_MODE_SIMPLE_BLOCK_ADD
});

export const deleteELFilterModeSimpleBlock = blockIndex => ({
  type: EL_FILTER_MODE_SIMPLE_BLOCK_DELETE,
  blockIndex
});

export const addELFilterModeSimpleCondition = blockIndex => ({
  type: EL_FILTER_MODE_SIMPLE_CONDITION_ADD,
  blockIndex
});

export const deleteELFilterModeSimpleCondition = (blockIndex, conditionIndex) => ({
  type: EL_FILTER_MODE_SIMPLE_CONDITION_DELETE,
  blockIndex,
  conditionIndex
});

export const changeELFilterModeSimpleValues = fields => ({
  type: EL_FILTER_MODE_SIMPLE_VALUES_CHANGE,
  fields
});

export const readELFilterModeSimpleValues = (dimensionId, separator, delimiter, hasHeader, csvPath) => ({
  ...postRequest(
    EL_FILTER_MODE_SIMPLE_VALUES_READ,
    getCsvTableColumnPreviewUrl(separator, delimiter, hasHeader, csvPath),
    {
      SelCols: [dimensionId],
      PageNum: 1,
      PageSize: -1
    }
  ),
  dimensionId
});

export const resetELFilterModeSimpleValues = dimensionId => ({
  type: EL_FILTER_MODE_SIMPLE_VALUES_RESET,
  dimensionId
});

export const resetELFilter = () => ({
  type: EL_FILTER_RESET
});

export const getELCsvStructure = (csvSeparator, csvDelimiter, csvHasHeader, csvServerPath, appLang) => ({
  ...getRequest(
    EL_STRUCTURE_CSV_HEADER_READ,
    getCsvHeaderUrl(csvSeparator, csvDelimiter, csvHasHeader, csvServerPath),  
  ),
  appLang
});

export const setELStructureColumnType = (columnId, columnType, transColId, langCode) => ({
  type: EL_STRUCTURE_COLUMN_TYPE_SET,
  columnId,
  columnType,
  transColId, 
  langCode
});

export const setELDimensionsColumnsValues = (columnId, role, association) => ({
  type: EL_DIMENSIONS_COLUMNS_SET,
  columnId,
  role,
  association
});

export const readELCodelists = () => getRequest(
  EL_CODELISTS_READ,
  getCodelistUrl(),
);

export const setELAttributesColumnsValues = (columnId, refers, dimensions, association) => ({
  type: EL_ATTRIBUTES_COLUMNS_SET,
  columnId,
  refers,
  dimensions,
  association
});

export const setELSemanticColumnsConcept = (columnId, conceptType, conceptName, conceptLang, conceptSchema, concept) => ({
  type: EL_SEMANTIC_COLUMNS_SET,
  columnId,
  conceptType,
  conceptName,
  conceptLang,
  conceptSchema,
  concept
})

export const readELConceptSchemes = () => getRequest(
  EL_CONCEPT_SCHEMES_READ,
  getConceptSchemeUrl(),
);

export const readELConcepts = (csTriplet) => getRequest(
    EL_CONCEPTS_READ,
    getConceptSchemeUrl(csTriplet)
);

export const resetELConcepts = () => ({
  type: EL_CONCEPTS_CLEAR
});


export const submitELMetadata = (endpointId, sdcDataflowTriplet) => postRequest(
  EL_METADATA_SUBMIT,
  getImportDSDFromDataflowUrl(endpointId, sdcDataflowTriplet),
  null,
  t => ({
    success: t('components.easyLoading.messages.submitMetadata.success')
  })
);

export const hideElMetadataReport = () => ({
  type: EL_METADATA_REPORT_HIDE
});

export const preloadELCSV = (separator, delimiter, hasHeader, filePath, tid) => getRequest(
  EL_METADATA_CSV_PRELOAD,
  getPreloadCsvUrl(separator, delimiter, hasHeader, filePath, tid)
);

export const setELLoadTableExists = (value) => ({
  type: EL_LOAD_TABLE_SET_EXISTS,
  value
});

export const createELArtefacts = (structureColumns, filterStr,dstDataflow, tableName, inStagingDb, appLang) => {
  
  let requestsMethod = [];
  let requestsUrl = [];
  let requestsBody = [];
  let codelistColumns = null;
  let conceptSchemaDefinition = null;

  const conceptRequest = getCreateConceptRequest(structureColumns, dstDataflow, appLang);
  if (conceptRequest !== null) {
    requestsMethod = requestsMethod.concat(conceptRequest.methods);
    requestsUrl = requestsUrl.concat(conceptRequest.urls);
    requestsBody = requestsBody.concat(conceptRequest.body); 
    conceptSchemaDefinition = conceptRequest.data;   
  }

  const codelistRequests = getCreateCodelistsRequests(structureColumns, filterStr, dstDataflow.id, tableName, inStagingDb);

  if (codelistRequests !== null) {
    requestsMethod = requestsMethod.concat(codelistRequests.methods);
    requestsUrl = requestsUrl.concat(codelistRequests.urls);
    requestsBody = requestsBody.concat(codelistRequests.body)
    codelistColumns = codelistRequests.data;
  }

  if (requestsMethod.length === 0) {
    return ({
      type: EL_CREATE_ARTEFACTS,
    });
  }
  
  return {
    ...allRequest(
      EL_CREATE_ARTEFACTS,
      requestsMethod,
      requestsUrl,
      requestsBody,
      t => ({
        start: t('components.easyLoading.messages.createCodelistsConceptSchema.start'),
        success: t('components.easyLoading.messages.createCodelistsConceptSchema.success')
      })
    ),
    codelistColumns,
    conceptSchemaDefinition,
  } 
};

export const deleteELCreatedArtefacts = (toDeleteCodelists, toDeleteConceptSchema) => {

  const requestsMethod = [];
  const requestsUrl = [];
  if (toDeleteConceptSchema) {
    requestsMethod.push(REQUEST_METHOD_DELETE);
    requestsUrl.push(getDeleteArtefactUrl("ConceptScheme", toDeleteConceptSchema.conceptSchema));
  }

  if (toDeleteCodelists) {
    Object.keys(toDeleteCodelists).forEach(column => {
      const codelistId = toDeleteCodelists[column];
      const triplet = {
        id: codelistId,
        agencyID:"AST",
        version:"1.0"
      }
      requestsMethod.push(REQUEST_METHOD_DELETE);
      requestsUrl.push(getDeleteArtefactUrl("CodeList", triplet));  
    });
  }  

  if (requestsMethod.length === 0) {
    return ({
      type: EL_DELETE_CREATED_ARTEFACTS
    });
  }


  return {
    ...allRequest(
      EL_DELETE_CREATED_ARTEFACTS,
      requestsMethod,
      requestsUrl
    )
  } 

}

export const createELDsd = (structureColumns, dstDataflow, appLang, codelists, conceptSchema, astTerritoryDimId) => {
  const dsd = getDataflowDSD(structureColumns, dstDataflow, appLang, codelists, conceptSchema, astTerritoryDimId);
  return {
    ...postRequest(
      EL_CREATE_DSD,
      getCreateArtefactsUrl(),
      getSdmxJsonFromSdmxJsonStructures(
        [getSdmxJsonStructureFromDsd(dsd)],
        SDMX_JSON_DSD_LIST_KEY
      ),
      t => ({
        start: t('components.easyLoading.messages.createDsd.start'),
        success: t('components.easyLoading.messages.createDsd.success')
      }),
    ),
    dsdTriplet: {
      id: dsd.id,
      agencyID: dsd.agencyID,
      version: dsd.version
    }
  }
}

export const changeElPublishDataflow = publishDf => ({
  type: EL_PUBLISH_DATAFLOW_CHANGE,
  publishDf
});

export const changeElTranscodeDataflow = transcodeDf => ({
  type: EL_TRANSCODE_DATAFLOW_CHANGE,
  transcodeDf
});

export const submitELDataCreate = (endpointId, sdcDataflowTriplet, dstDataflowTriplet, datasetName, categoryId, filterStr, publishDf, transcodeDf) => postRequest(
  EL_DATA_CREATE_SUBMIT,
  getEasyLoadDataFromSdmxUrl(endpointId, sdcDataflowTriplet, dstDataflowTriplet, categoryId, publishDf, transcodeDf),
  {
    labels: datasetName,
    filter: getServerQueryObj(null, getFilterObjFromStr(convertFilterStrWithSimpleFilterForTimePeriod(filterStr))).Filter
  },
  t => ({
    success: t('components.easyLoading.messages.submitData.success')
  }),
  undefined,
  undefined,
  undefined,
  true
);

export const submitELDataUpdate = (endpointId, sdcDataflowTriplet, dstDDBDataflowId, filterStr, transcodeDf) => postRequest(
  EL_DATA_UPDATE_SUBMIT,
  getEasyUpdateDataFromSdmxUrl(endpointId, sdcDataflowTriplet, dstDDBDataflowId, transcodeDf),
  getServerQueryObj(null, getFilterObjFromStr(convertFilterStrWithSimpleFilterForTimePeriod(filterStr))).Filter,
  t => ({
    success: t('components.easyLoading.messages.submitData.success')
  }),
  undefined,
  undefined,
  undefined,
  true
);

export const submitELDataFromFileCreate = (structureColumns, astTerritoryDimId, datasetName, filePath, separator, delimiter, hasHeader, DsId, DsAg, DsVs, CategoryId, DsdCode, mappFilePath, publishDf, executeTrans, filterStr) => {

  const componentMapping = getCreateFileComponentMapping(structureColumns, astTerritoryDimId);
  const url = getEasyLoadDataFromFileUrl(filePath, separator, delimiter, hasHeader, DsId, DsAg, DsVs, CategoryId, mappFilePath, publishDf, executeTrans);
  
  return ( 
    postRequest(
      EL_DATA_CREATE_FROM_FILE_SUBMIT,
      url,
      {
        labels: datasetName,
        filter: getServerQueryObj(null, getFilterObjFromStr(filterStr)).Filter,
        mapp: componentMapping,
        DsdCode: DsdCode
      },
      t => ({
        success: t('components.easyLoading.messages.submitData.success')
      }),
      undefined,
      undefined,
      undefined,
      true
    )
  )};

export const submitELDataFromDbCreate = (structureColumns, astTerritoryDimId, tableName, datasetName, DsId, DsAg, DsVs, CategoryId, DsdCode, publishDf, executeTrans, filterStr) => {

    const componentMapping = getCreateFileComponentMapping(structureColumns, astTerritoryDimId)
    
    return ( 
      postRequest(
        EL_DATA_CREATE_FROM_DB_SUBMIT,
        getEasyLoadDataFromDbUrl(tableName, DsId, DsAg, DsVs, CategoryId, publishDf, executeTrans),
        {
          labels: datasetName,
          filter: getServerQueryObj(null, getFilterObjFromStr(filterStr)).Filter,
          mapp: componentMapping,
          DsdCode: DsdCode
        },
        t => ({
          success: t('components.easyLoading.messages.submitData.success')
        }),
        undefined,
        undefined,
        undefined,
        true
      )
  )};

export const submitELDataFromFileUpdate = (datasetName, filePath,separator, delimiter, hasHeader, ddbDataflowId, currentMapping,components, mappFilePath, transcodeDf, filterStr) => {
  let componentMapping = null;
  let mappId = null;
  if (currentMapping.IDMapping !== -1) {  
    mappId = currentMapping.IDMapping;
  }
  else {
    componentMapping = getUpdateFileComponentMapping(components);
  }
  const url = getEasyUpdateDataFromFileUrl(filePath, separator, delimiter, hasHeader, ddbDataflowId, mappId, mappFilePath, transcodeDf);
  
  return ( 
    postRequest(
      EL_DATA_UPDATE_FROM_FILE_SUBMIT,
      url,
      {
        labels: datasetName,
        filter: getServerQueryObj(null, getFilterObjFromStr(filterStr)).Filter,
        mapp: componentMapping
      },
      t => ({
        success: t('components.easyLoading.messages.updateData.success')
      }),
      undefined,
      undefined,
      undefined,
      true
    )
  )};  

export const submitELDataFromDBUpdate = (datasetName, tableName,ddbDataflowId,currentMapping,components,transcodeDf,filterStr) => {
  let componentMapping = null;
  let mappId = null;
  if (currentMapping.IDMapping !== -1) {  
    mappId = currentMapping.IDMapping;
  }
  else {
    componentMapping = getUpdateFileComponentMapping(components);
  }
  const url = getEasyUpdateDataFromDbUrl(tableName, ddbDataflowId, mappId, transcodeDf);
  
  return ( 
    postRequest(
      EL_DATA_UPDATE_FROM_DB_SUBMIT,
      url,
      {
        labels: datasetName,
        filter: getServerQueryObj(null, getFilterObjFromStr(filterStr)).Filter,
        mapp: componentMapping
      },
      t => ({
        success: t('components.easyLoading.messages.updateData.success')
      }),
      undefined,
      undefined,
      undefined,
      true
    )
  )};

export const getELDataImportStatus = dataflowTriplet => getRequest(
  EL_DATA_IMPORT_STATUS_GET,
  getDataUploadStatusUrl(dataflowTriplet),
  undefined,
  undefined,
  undefined,
  undefined,
  true
);

export const resetEl = () => ({
  type: EL_RESET
});

export const readASTTerritorialCodelistConcept = (codelist,conceptScheme, concept) => ({
  ...allRequest(
    EL_READ_AST_TERRITORIAL_CODELIST_CONCEPT,
    [REQUEST_METHOD_GET, REQUEST_METHOD_GET],
    [getCodelistUrl(getArtefactTripletFromString(codelist)),getConceptSchemeUrl(getArtefactTripletFromString(conceptScheme))],    
  ),
  codelist,
  conceptScheme,
  concept
});




// WEBPACK FOOTER //
// ./src/components/easy-loading/actions.js